import React from 'react';
import { useTranslation } from 'react-i18next';
import { getCurrencies } from '../utils/enums';

const CurrencySelect = ({ label, selectId, defaultSelectedItem, setSelectedItem, showLabel = true }) => {
  const { t } = useTranslation();
  const currencies = getCurrencies(t);

  return (
    <div>
      {showLabel && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <select
        id={selectId}
        value={defaultSelectedItem || ''}
        onChange={(e) => {
          const selectedCurrency = currencies.find(c => c.value === parseInt(e.target.value));
          setSelectedItem(selectedCurrency);
        }}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option value="">{t('enums.currencies.Select') || 'Select Currency'}</option>
        {currencies.map(currency => (
          <option key={currency.value} value={currency.value}>
            {currency.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CurrencySelect;
